import { snakeCase } from 'lodash-es';
import mapKeysDeep from './map-keys-deep';

export default function mapKeysToSnakeCase(obj, recursive = false) {
  return mapKeysDeep(obj, (v, k) => snakeCase(k), recursive);
}
